import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "../../styles/Services/ServicesOptions.scss";
import { Col, Container, Form, Image, Row } from "react-bootstrap";
import brandImage1 from "../../assets/images/brandImage1.png";
import brandImage2 from "../../assets/images/brandImage2.png";
import brandImage3 from "../../assets/images/brandImage3.png";
import brandImage4 from "../../assets/images/brandImage4.png";
import brandLogo from "../../assets/images/brandLogo.png";

import serviceGif from "../../assets/gif/services.gif";
import { AiOutlineArrowRight } from "react-icons/ai";
const ServicesOptions = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Container>
      <h1 className="services-title title">Services</h1>
      <img src={serviceGif} alt="gif" className="service-gif" loading="lazy" />
      {/* try */}
      <button onClick={handleShow} className="get-a-quote">
        GET A QUOTE
        <AiOutlineArrowRight className="text-white fs-4 get-a-quote-icon-arrow"></AiOutlineArrowRight>
      </button>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement={"end"}
        className="service-page-form"
      >
        <Offcanvas.Header closeButton>
          <Image
            src={brandLogo}
            alt="brand-logo"
            className="d-block m-auto py-4"
          />
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Form.Group
              className="mb-3 custom-form-group"
              controlId="formBasicPassword"
            >
              <Form.Label className="label-title">Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Your Name"
                className="place-holder-custom-design "
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="label-title">Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Your Email"
                className="place-holder-custom-design"
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="label-title">Phone</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter your phone no."
                className="place-holder-custom-design"
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="label-title">Comment</Form.Label>
              <Form.Control
                as="textarea"
                rows="1"
                cols="30"
                placeholder="Describe your project"
                className="place-holder-custom-design"
                style={{
                  backgroundColor: "transparent",
                  color: "#7D7A79",
                  borderTop: "0",
                  borderLeft: "0",
                  borderRight: "0",
                  borderBottom: "1.5px solid #7D7A79",
                  padding: "10px 0",
                  borderRadius: "0",
                }}
              />
            </Form.Group>
            <button type="submit" className="form-submit">
              Submit
            </button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
      <Container className="main-category-container">
        <Row className="category-description">
          <Col md={8}>
            Viverra ut potenti aliquam feugiat dui imperdiet laoreet tempus sed.
            Elit cursus est lorem in est Viverra ut potenti aliquam feugiat dui
            imperdiet laoreet tempus sed.
          </Col>
        </Row>
        <div className="sub-category-items">
          <h1 className="sub-category-item">Brand</h1>
          <h1 className="sub-category-item">Brand</h1>
          <h1 className="sub-category-item">Brand</h1>
        </div>
        <div className="main-brand-section">
          <h1 className="main-category-title">Brand</h1>
          <img
            src={brandImage1}
            alt="brand-img"
            className="img-fluid"
            loading="lazy"
          />
        </div>
      </Container>
      {/* 2 */}
      <Container className="main-category-container">
        <Row className="category-description">
          <Col md={4}></Col>
          <Col md={8} className="text-end">
            Viverra ut potenti aliquam feugiat dui imperdiet laoreet tempus sed.
            Elit cursus est lorem in est Viverra ut potenti aliquam feugiat dui
            imperdiet laoreet tempus sed.
          </Col>
        </Row>
        <div className="sub-category-items d-flex justify-content-end">
          <h1 className="sub-category-item-2">Brand</h1>
          <h1 className="sub-category-item-2">Brand</h1>
          <h1 className="sub-category-item-2">Brand</h1>
        </div>
        <div className="main-brand-section">
          <h1 className="main-category-title-2">Brand2</h1>
          <img
            src={brandImage2}
            alt="brand-img"
            className="img-fluid"
            loading="lazy"
          />
        </div>
      </Container>
      {/* 3 */}
      <Container className="main-category-container">
        <Row className="category-description">
          <Col md={8}>
            Viverra ut potenti aliquam feugiat dui imperdiet laoreet tempus sed.
            Elit cursus est lorem in est Viverra ut potenti aliquam feugiat dui
            imperdiet laoreet tempus sed.
          </Col>
        </Row>
        <div className="sub-category-items">
          <h1 className="sub-category-item">Brand</h1>
          <h1 className="sub-category-item">Brand</h1>
          <h1 className="sub-category-item">Brand</h1>
        </div>
        <div className="main-brand-section">
          <h1 className="main-category-title">Brand3</h1>
          <img
            src={brandImage3}
            alt="brand-img"
            className="img-fluid"
            loading="lazy"
          />
        </div>
      </Container>
      {/* 4 */}
      <Container className="main-category-container">
        <Row className="category-description">
          <Col md={4}></Col>
          <Col md={8} className="text-end">
            Viverra ut potenti aliquam feugiat dui imperdiet laoreet tempus sed.
            Elit cursus est lorem in est Viverra ut potenti aliquam feugiat dui
            imperdiet laoreet tempus sed.
          </Col>
        </Row>
        <div className="sub-category-items d-flex justify-content-end">
          <h1 className="sub-category-item-2">Brand</h1>
          <h1 className="sub-category-item-2">Brand</h1>
          <h1 className="sub-category-item-2">Brand</h1>
        </div>
        <div className="main-brand-section">
          <h1 className="main-category-title-2">Brand4</h1>
          <img
            src={brandImage4}
            alt="brand-img"
            className="img-fluid"
            loading="lazy"
          />
        </div>
      </Container>
    </Container>
  );
};

export default ServicesOptions;
